import { ConfigProvider, Segmented } from 'antd';

/**
 *
 * @returns
 */
export const BaseSegmented = ({options={options}, value=undefined, size='large', disabled}) => {
  return (
    <ConfigProvider
        theme={{
          components: {
            Segmented: {
              itemColor:'#969696',
              itemHoverBg: 'rgba(0, 0, 0, 0.03)'
            },
          },
          token: {
              borderRadius:'99px',
              colorText: '#282B3E',
              colorTextDisabled: '#969696'
          },
        }}
    >
        <Segmented options={options} value={value} size={size} disabled={disabled || false} /> 
    </ConfigProvider>
  )
}
